<!-- 内部演示使用 -->
<template>
  <div class="home">
    <div class="homeMobile">
      <header>
        <i @click="drawer = true" class="el-icon-menu"></i>
        <img :src="config.icon && config.icon != '' ? config.icon : require('@/assets/img/logo2.png')">
        <el-popconfirm icon-color="red"  title="是否清除所有会话?" @confirm="clearCurrentChat">
          <img slot="reference" src="@/assets/img/clear.png">
        </el-popconfirm>
      </header>
      <main>
        <div class="mainContent" ref="messageContainer2">
          <div v-for="(msg, index) in messages[currentChatId]" :key="index" class="messageBox" :class="msg.role">
            <div class="message" :class="{ userMessage: msg.role === 'user' }">
              <div class="messageContent">
                <div class="messageText">
                  <template v-if="msg.role === 'user'">{{ msg.content }}</template>
                  <template v-else>
                    <div v-html="parseMarkdown(msg.content)"></div>
                    <p v-if="msg.role !== 'user' && index === 0">
                      <span @click="defaultSend(item)" v-for="(item, i) in titleList[chooseTitle].questionList" :key="i"><u></u>{{ item }}</span>
                    </p>
                    <span v-if="msg.loading" class="loadingDots"></span>
                    <span v-if="msg.loading" class="loadingDots2"></span>
                    <span v-if="msg.loading" class="loadingDots3"></span>
                  </template>
                </div>
                <!-- 猜你想问 -->
                <div v-if="msg.role !== 'user' && msg.guessList && msg.guessList.length > 0" class="guessBox">
                  <i @click="defaultSend(res)" v-for="(res, i) in msg.guessList" :key="i">{{ res }}</i>
                </div>
                <!-- 复制按钮 -->
                <div @click="copyText(msg.content)" class="botCopy" v-if="msg.role === 'assistant' && msg.loading == false && index !== 0">
                  <i class="el-icon-copy-document"></i>
                </div>
                <div v-if="msg.role !== 'user' && msg.loading" @click="stopMessage" class="messageStop">停止回答</div>
              </div>
            </div>
          </div>
        </div>
        <div class="mainFooter" :class="{'focused': isFocused}">
          <el-input :autosize="{ minRows: 1, maxRows: 4 }" type="textarea" @keydown.native="inpSend($event)" @focus="onFocus" @blur="onFocus" placeholder="请输入问题" maxlength="1500" v-model="question"></el-input>
          <p @click="send" v-if="question.length == 0 && isSending == false"><img src="@/assets/img/nosend.png" alt=""></p>
          <p @click="send" v-else-if="question.length > 0"><img src="@/assets/img/send.png" alt=""></p>
          <p class="stopP" @click="stopMessage" v-else-if="isSending"><i class="el-icon-loading"></i></p>
        </div>
      </main>
      <el-drawer
        title="问答历史"
        :visible.sync="drawer"
        direction="ltr">
        <div class="drawerContent">
          <div class="drawerNav">
            <img src="@/assets/img/logo.png" alt="">
          </div>
          <p>
            <span>最近使用</span>
            <span>更多
              <u>
                <i class="el-icon-arrow-up"></i>
                <i class="el-icon-arrow-down"></i>
              </u>
            </span>
          </p>
          <ul>
            <li
              v-for="(item, index) in titleList"
              :key="index"
              :class="{ active: item.chatId === currentChatId }"
              @click="getDefaultChat(index)"
            >
              <img src="@/assets/img/icon.png" alt="">
              <span class="textHidden">{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </el-drawer>
    </div>
    <div class="homePC">
      <header>
        <img :src="config.icon && config.icon != '' ? config.icon : require('@/assets/img/logo.png')">
      </header>
      <main>
        <aside>
          <p>
            <span>最近使用</span>
            <span>更多
              <u>
                <i class="el-icon-arrow-up"></i>
                <i class="el-icon-arrow-down"></i>
              </u>
            </span>
          </p>
          <ul>
            <li
              v-for="(item, index) in titleList"
              :key="index"
              :class="{ active: item.chatId === currentChatId }"
              @click="getDefaultChat(index)"
            >
              <img src="@/assets/img/icon.png" alt="">
              <el-tooltip v-if="item.name.length > 12" class="item" effect="light" :content="item.name" placement="right">
                <span class="textHidden">{{ item.name }}</span>
              </el-tooltip>
              <span v-else class="textHidden">{{ item.name }}</span>
            </li>
          </ul>
          <div  @click="configDialog = true" class="setFooter">问答配置</div>
        </aside>
        <article>
          <div class="artHeader">
            <div class="tip">
              <el-popconfirm icon-color="red"  title="是否清除所有会话?" @confirm="clearCurrentChat">
                <p slot="reference"><img src="@/assets/img/clear.png"><span>清除所有会话</span></p>
              </el-popconfirm>
            </div>
            <div class="artBox" ref="messageContainer">
              <div v-for="(item, index) in messages[currentChatId]" :key="index" :class="item.role === 'user' ? 'questionBox' : 'answerBox'">
                <div class="contentBox">
                  <div>
                    <img v-if="item.role !== 'user'" src="@/assets/img/AI.png" alt="">
                    <div class="messageP">
                      <p v-html="item.content"></p>
                      <p v-if="item.role !== 'user' && index === 0">
                        <span @click="defaultSend(item)" v-for="(item, i) in titleList[chooseTitle].questionList" :key="i"><u></u>{{ item }}</span>
                      </p>
                      <span v-if="item.loading && item.role !== 'user'" class="loadingDots"></span>
                      <span v-if="item.loading && item.role !== 'user'" class="loadingDots2"></span>
                      <span v-if="item.loading && item.role !== 'user'" class="loadingDots3"></span>
                      <!-- 猜你想问 -->
                      <div v-if="item.role !== 'user' && item.guessList && item.guessList.length > 0" class="guessBox">
                         <i @click="defaultSend(res)" v-for="(res, i) in item.guessList" :key="i">{{ res }}</i>
                       </div>
                      <span @click="copyText(item.content)" class="botCopy" v-if="item.role === 'assistant' && item.loading == false && index !== 0">
                        <i class="el-icon-copy-document"></i>复制
                      </span>
                    </div>
                    <img v-if="item.role === 'user'" src="@/assets/img/user.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="artFooter">
            <el-input type="textarea" placeholder="请输入问题（Shift+Enter 换行)" maxlength="1500" v-model="question" ref="textarea"
              @keydown.native="inpSend($event)" @input="resizeTextarea" :autosize="{ minRows: 2, maxRows: 10 }"></el-input>
            <el-button v-if="isSending === false" @click="send" class="lightBtn">发送</el-button>
            <el-button v-else @click="stopMessage" class="stopBtn">停止</el-button>
          </div>
        </article>
      </main>
      <!-- 配置弹框 -->
      <el-dialog class="configDialog" title="请选择使用方式" :visible.sync="configDialog" :close-on-click-modal="false">
        <div>
          <ul>
            <li class="listItem" @click="selectImage(1)" @mouseenter="chooseDialogBox = 1" :class="chooseDialogBox === 1 ? 'activeLi' : ''">
              <div class="zoomMask">
                <i class="el-icon-full-screen"></i>
              </div>
            </li>
            <li class="listItem" @click="selectImage(2)" @mouseenter="chooseDialogBox = 2" :class="chooseDialogBox === 2 ? 'activeLi' : ''">
              <div class="zoomMask">
                <i class="el-icon-full-screen"></i>
              </div>
            </li>
            <li class="listItem" @click="selectImage(3)" @mouseenter="chooseDialogBox = 3" :class="chooseDialogBox === 3 ? 'activeLi' : ''">
              <div class="zoomMask">
                <i class="el-icon-full-screen"></i>
              </div>
            </li>
          </ul>
          <div class="configContent">
            <p v-if="chooseDialogBox === 1"><span>将下面链接复制到浏览器打开</span><i @click="copyConfig(1)" class="el-icon-copy-document"></i></p>
            <p v-if="chooseDialogBox === 2"><span>复制下面 iframe 加入到你的网站中</span><i @click="copyConfig(2)" class="el-icon-copy-document"></i></p>
            <p v-if="chooseDialogBox === 3"><span>将下面代码加入到你的网站中</span></p>
            <div v-if="chooseDialogBox === 1" class="configMain"><p>https://aq.pogpt.cn?icon=(填入图标地址)</p></div>
            <div v-if="chooseDialogBox === 2" class="configMain">
              <p>
<pre style="margin: -20px 0;">
  <code>
    &lt;iframe
      src="https://aq.pogpt.cn?icon=(填入图标地址)"
      style="width: 100%; height: 100%;"
      frameborder="0" 
      allow="*"
    /&gt;
  </code>
</pre>
              </p>
            </div>
            <div v-if="chooseDialogBox === 3" class="configMain">
              <p>
<pre style="margin: -20px 0;">
  <code>
    &lt;!-- 小图标(data-open-icon) 是否支持拖拽(data-drag) 是否默认打开(data-default-open) --&gt;
    &lt;script type="text/javascript"&gt;
      (function() {
        var s = document.createElement('script');
        s.src = 'https://aq.pogpt.cn/embedChatbot.js?_t=' + new Date().getTime();
        s.id = 'chatbot-iframe';
        s.setAttribute('data-bot-src', 'https://aq.pogpt.cn?icon=(填入图标地址)&agent=(true)');
        s.setAttribute('data-default-open', 'false');
        s.setAttribute('data-drag', 'false');
        s.setAttribute('data-open-icon', 'http://img.spolicy.com/-20250916103658.');
        document.body.appendChild(s);
      })();
    &lt;/script&gt;
  </code>
</pre>
              </p>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 全屏显示组件 -->
      <div class="fullscreenOverlay" :class="{ active: showFullscreen }" @click="closeFullscreen">
        <div :style="{ backgroundImage: 'url(' + fullscreenImage + ')' }"></div>
        <i class="el-icon-close"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { questionTemplateApi } from '@/api';
import { marked } from 'marked';
export default {
  name: 'HelloWorld',
  data() {
    return {
      // 可配置项------------------------
      config: {
        icon: '',
        token: '',
        appId: ''
      },
      // -------------------------------
      isFocused: false, // 输入框是否聚焦
      fullscreenImage: '',
      showFullscreen: false, // 全屏显示标识
      chooseDialogBox: 1, // 选中的配置方式
      configDialog: false, // 控制新增弹框
      currentChatId: null, // 当前选中的对话框
      question: '',
      messages: {}, // 存储不同对话框的消息
      isLoading: false,
      isSending: false, // 发送状态标识
      isStopped: false, // 停止标识
      abortController: null, // AbortController实例
      chooseTitle: 0, // 选择的历史对话框
      titleList: [],
      drawer: false,
    };
  },
  mounted() {
    // 1.根据网址链路信息获取参数
    const urlParams = new URLSearchParams(window.location.search);
    const queryParams = {};
    urlParams.forEach((value, key) => {
      queryParams[key] = value;
    })
    this.config = queryParams
    // 获取问答模板
    this.getQuestionTemplate()
  },
  methods: {
    resizeTextarea() {
      this.$refs.textarea.$el.style.height = 'auto';
      this.$refs.textarea.$el.style.height = this.$refs.textarea.$el.scrollHeight + 'px';
    },
    onFocus() {
      this.isFocused = !this.isFocused;
    },
    // 获取猜你想问参数
    async getSuggest() {
      const url = '/api/core/ai/agent/v2/createQuestionGuide'
      const headers = {
        Authorization: 'Bearer fastgpt-' + this.currentChat.key,
        'Content-Type': 'application/json',
      }
      const data = {
        appId: this.titleList[0].appId,
        chatId: this.currentChatId,
        // qusetionGuideType: {
        //   open: true,
        //   model: "优策PoPGPT",
        //   customPrompt: "你是一个智能助手，请根据用户的问题生成猜你想问。"
        // },
      }
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data),
        });
        if (!response.ok) {
          throw new Error('网络响应错误');
        }
        const res = await response.json()
        this.$set(this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1], 'guessList', res.data)
        this.$forceUpdate()
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    // 选中图片
    selectImage(index) {
      switch (index) {
        case 1:
          this.fullscreenImage = require('@/assets/img/1.png');
          break;
        case 2:
          this.fullscreenImage = require('@/assets/img/2.png');
          break;
        case 3:
          this.fullscreenImage = require('@/assets/img/3.png');
          break;
      }
      this.showFullscreen = true;
    },
    closeFullscreen() {
      this.showFullscreen = false;
    },
    // 获取问答模板
    async getQuestionTemplate() {
      this.titleList = []
      const { data: res } = await questionTemplateApi()
      if (res.code !== 200) return this.$message.error(res.message || '未知错误')
      let titleArray = res.data
      titleArray.forEach(item => {
        this.titleList.push({
          chatId: Math.floor(Math.random() * 1000000).toString().padStart(6, '0'),
          key: item.key,
          appId: item.appid,
          name: item.name,
          questionList: [],
          content: ''
        })
      })
      // 获取初始聊天内容
      if (this.titleList.length > 0) {
        this.currentChatId = this.titleList[0].chatId
        this.currentChat = this.titleList[0]
        this.getDefaultChat(0)
      }
    },
    async getDefaultChat(index) {
      const url = '/api/core/chat/init?chatId=' + this.currentChatId + '&appId=' + this.titleList[index].appId + '&_t=' + new Date().getTime();
      const headers = {
        Authorization: 'Bearer fastgpt-' + this.currentChat.key,
        'Content-Type': 'application/json',
      }
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: headers,
        });
        if (!response.ok) {
          throw new Error('网络响应错误');
        }
        const res = await response.json()
        const welcomeText = res.data.app.chatConfig.welcomeText;
        const parsedText = welcomeText.split('\n');
        // 标题
        this.titleList[index].content = parsedText[0]
        // 内容
        this.titleList[index].questionList =  parsedText.slice(1).map(question => question.slice(1, -1))
        // 设置左侧题目
        this.titleList[index].name = res.data.app.name
        // 设置网站名称
        document.title = res.data.app.name
        // 发起默认会话
        this.changeChat(this.titleList[index], index)
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    copyConfig(index) {
      let textToCopy;
      if (index === 1) {
        textToCopy = 'https://aq.pogpt.cn?icon=(填入图标地址)'
      } else if (index === 2) {
        textToCopy = '<iframe src="https://aq.pogpt.cn?icon=(填入图标地址)" style="width: 100%; height: 100%;" frameborder="0" allow="*"></iframe>'
      }
      // 创建一个临时的 textarea 元素用于复制文本
      const textarea = document.createElement('textarea')
      textarea.value = textToCopy
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('复制成功!')
    },
    parseMarkdown(content) {
      return marked(content);
    },
    stopMessage() {
      if (this.isSending) {
        this.isStopped = true;
        if (this.abortController) {
          this.abortController.abort();
        }
        const lastMessage = this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1];
        lastMessage.content = lastMessage.content + '<p style="color: red;"> 已停止生成!</p>';
        lastMessage.loading = false;
        this.isSending = false;
      }
    },
    changeChat(result, index) {
      this.chooseTitle = index
      this.currentChatId = result.chatId
      this.currentChat = result
      if (!this.messages[result.chatId]) {
        this.messages[result.chatId] = []
      }
      if (this.messages[result.chatId].length === 0) {
        // 配置对应的默认回答
        this.messages[result.chatId].push({
          role: 'assistant',
          content: `${result.content}`,
          loading: false,
        })
        this.$forceUpdate()
      }
      this.drawer = false
    },
    clearCurrentChat() {
      if (!this.currentChatId) return false
      // 停止会话
      this.stopMessage()
      // 重新设置chartId
      this.titleList[this.chooseTitle].chatId = Math.floor(Math.random() * 1000000).toString().padStart(6, '0')
      this.currentChatId = this.titleList[this.chooseTitle].chatId
      this.messages = [];
    },
    inpSend(event) {
      if (event.key === 'Enter') {
        if (!event.shiftKey) {
          event.preventDefault();
          this.send();
        }
      }
    },
    // 默认回答
    defaultSend(defaultQuestion) {
      this.question = defaultQuestion
      this.send()
    },
    // 发送会话
    async send() {
      if (!this.question.trim() || this.isLoading) return
      this.abortController = new AbortController()
      this.isStopped = false
      this.isSending = true
      if (!this.currentChatId) {
        alert('请先选择一个会话或创建新会话')
        return;
      }
      if (!this.messages[this.currentChatId]) {
        this.messages[this.currentChatId] = [];
      }
      this.messages[this.currentChatId].push({
        role: 'user',
        content: this.question
      });
      this.messages[this.currentChatId].push({
        role: 'assistant',
        content: '',
        loading: true,
      });
      this.scrollToBottom()
      this.isLoading = true;
      const userMessage = this.question;
      this.question = '';
      const url = '/api/v1/chat/completions';
      // const url = 'http://116.148.212.170:7708/api/v1/chat/completions';
      const headers = {
        Authorization: 'Bearer fastgpt-' + this.currentChat.key,
        'Content-Type': 'application/json',
      };
      const data = {
        stream: true,
        chatId: this.currentChatId,
        messages: [{ role: 'user', content: userMessage }],
      }
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data),
          signal: this.abortController.signal,
        });
        if (!response.ok) {
          throw new Error('网络响应错误');
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let lastMessage = this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1];
        let markdownContent = ''; // 累积完整的 Markdown 内容
        // eslint-disable-next-line no-constant-condition
        while (true) {
          if (this.isStopped) break;
          const { done, value } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value);
          const lines = chunk.split('\n').filter((line) => line.trim());
          for (const line of lines) {
            if (line.startsWith('data: ')) {
              const dataStr = line.slice(6);
              if (dataStr === '[DONE]') {
                lastMessage.loading = false;
                break;
              }
              if (this.isStopped) break;
              try {
                const parsedData = JSON.parse(dataStr)
                const content = parsedData.choices[0]?.delta?.content || ''
                markdownContent += content; // 累积 Markdown 内容
                // 使用 marked 库将 markdown 转换为 html
                const htmlContent = marked(markdownContent);
                this.$set(lastMessage, 'content', htmlContent)
                this.$forceUpdate()
                this.scrollToBottom()
              } catch (e) {
                console.error('解析数据错误:', e)
              }
            }
          }
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('请求已被中止');
        } else {
          console.error('请求失败:', error);
          this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].content = '发生错误，请重试';
          this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].loading = false;
        }
      } finally {
        this.isLoading = false;
        this.isSending = false;
        this.abortController = null;
        this.getSuggest()
      }
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer
        if (container) {
          container.scrollTop = container.scrollHeight
        }
        const container2 = this.$refs.messageContainer2
        if (container) {
          container2.scrollTop = container2.scrollHeight
        }
      })
    },
    copyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text || this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].content;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success('复制成功')
    },
  },
};
</script>

<style scoped lang="less">
.home {
  @media screen and (max-width: 900px) {
    .homeMobile {
      display: block;
      padding: .625rem 0;
      width: 100%;
      height: 100vh;
      background: linear-gradient(90deg, rgb(172, 185, 251), #8ba8fe 46%, rgb(162, 185, 251));
      background-size: 100% 100%;
      box-sizing: border-box;
      border: .125rem solid rgb(162, 185, 251);
      border-radius: .5rem;
      header {
        position: relative;
        padding: 0 .625rem 0.625rem;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2rem;
        border-bottom: .0625rem solid rgb(222, 224, 227);
        >i {
          position: absolute;
          left: 0.625rem;
          cursor: pointer;
          color: #fff;
          font-size: 1.5rem;
        }
        >img {
          height: 2.6rem;
          max-width: calc(100% - 7.5rem);
        }
        span img {
          position: absolute;
          top: 0;
          right: 0.625rem;
          cursor: pointer;
          height: 2rem;
        }
      }
      main {
        display: flex;
        flex-direction: column;
        padding: .625rem .5rem;
        height: calc(100vh - 4.56rem);
        background: linear-gradient( 146deg, #F2F6FE 0%, #FAF7FF 100%);
        border-radius: .5rem;
        .mainContent {
          flex: 1;
          overflow: auto;
          .messageBox {
            display: flex;
            margin: .625rem 0;
            .message {
              position: relative;
              margin-left: .125rem;
              padding: .625rem;
              border-radius: .5rem .5rem .5rem 0;
              background-color: #fff;
              border: .0625rem solid rgb(228, 231, 237);
              box-shadow: rgba(31, 35, 41, 0.12) 0 .085rem .25rem;
              .messageContent {
                .messageText {
                  text-align: left;
                  color: #333;
                  font-weight: 500;
                  font-size: 0.9rem;
                  p {
                    white-space: pre-wrap!important;
                    span {
                      margin-top: 0.1rem;
                      display: flex;
                      align-items: center;
                      cursor: pointer;
                      color: #333;
                      font-size: 0.9rem;
                      u {
                        margin-right: 0.4rem;
                        display: inline-block;
                        height: 0.4rem;
                        width: 0.4rem;
                        border-radius: 50%;
                        background-color: #333;
                      }
                    }
                  }
                }
                .guessBox {
                  display: flex;
                  flex-wrap: wrap;
                  i {
                    margin: .3rem 1rem .3rem 0;
                    padding: .3rem .6rem;
                    box-sizing: border-box;
                    border-radius: .2rem;
                    border: .075rem solid rgb(225, 226, 229);
                    cursor: pointer;
                    font-size: 0.9rem;
                    font-weight: 500;
                    line-height: 1.2rem;
                    color: rgba(51, 51, 51);
                    z-index: 10;
                  }
                  i:hover {
                    border-color: rgb(76, 136, 246);
                    color: rgb(76, 136, 246);
                  }
                  i:nth-child(3) {
                    margin-right: 0;
                  }
                }
              }
              .messageStop {
                position: absolute;
                bottom: -1.7rem;
                left: 0.4rem;
                width: 5rem;
                cursor: pointer;
                text-align: left;
                color: rgb(51, 112, 255);
                font-weight: bold;
                font-size: 0.9rem;
                z-index: 10;
              }
              .messageStop:hover {
                color: rgba(0, 123, 255, .5);
              }
            }
            .userMessage {
              margin-right: .125rem;
              border-radius: .5rem .5rem 0 .5rem;
              background: linear-gradient(90deg, rgb(172, 185, 251), #8ba8fe 46%, #8ba8fe 48%, rgb(162, 185, 251));
              border: .0625rem solid rgb(162, 185, 251);
              box-shadow: 0;
              .messageContent {
                .messageText {
                  text-align: left;
                  color: #fff;
                }
              }
            }
            .loadingDots, .loadingDots2, .loadingDots3 {
              margin-right: .3125rem;
              display: inline-block;
              width: .3125rem;
              height: .3125rem;
              background-color: #000;
              border-radius: 50%;
              animation: loading 0.8s infinite ease-in-out;
            }
            .loadingDots2 {
              animation: loading2 0.8s infinite ease-in-out;
            }
            .loadingDots3 {
              animation: loading3 0.8s infinite ease-in-out;
            }
            @keyframes loading {
              0% { transform: scale(1.5); }
              50% { transform: scale(1); }
              100% { transform: scale(1); }
            }
            @keyframes loading2 {
              0% { transform: scale(1); }
              50% { transform: scale(1.5); }
              100% { transform: scale(1); }
            }
            @keyframes loading3 {
              0% { transform: scale(1); }
              50% { transform: scale(1); }
              100% { transform: scale(1.5); }
            }
            .botCopy {
              margin-top: .3125rem;
              width: 1.25rem;
              cursor: pointer;
              color: rgba(185, 202, 255, 1);
              z-index: 10;
            }
          }
          .user {
            justify-content: right;
          }
        }
        .mainFooter.focused {
          border: 1px solid rgba(185, 202, 255, 1);
        }
        .mainFooter {
          position: relative;
          margin-top: 0.5rem;
          padding: 0 0.25rem;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          min-height: 2.85rem;
          background-color: #fff;
          border-radius: 0.6rem;
          box-sizing: border-box;
          box-shadow: 0 .375rem 1.5rem #1f232914;
          border: .0625rem solid #fff;
          /deep/ .el-textarea {
            .el-textarea__inner {
              padding: .8125rem .625rem;
              border: none!important;
              resize: none;
            }
          }
          p {
            margin: 0 .5rem .8rem;
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 50%;
            background-color: #fff;
            text-align: center;
            img {
              width: 1.5rem;
              height: 1.5rem;
            }
            i {
              color: #333;
              font-size: 1rem;
            }
          }
          .stopP {
            display: block;
            border: 0;
          }
        }
        .mainFooter::before {
          position: absolute;
          top: -2rem;
          left: 0;
          content: '';
          width: 100%;
          height: 1.5rem;
          background: linear-gradient(0deg,#f3f7f9 0%,rgba(243,247,249,0) 100%);
        }
      }
    }
    /deep/ .el-drawer {
      width: 80%!important;
      .el-drawer__header {
        display: none;
      }
      .drawerContent {
        padding: 1rem 1.5rem;
        background-color: #fff;
        box-sizing: border-box;
        .drawerNav {
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          height: 2rem;
          width: calc(100%);
          background-color: #eee;
          border-radius: 0.2rem;
          img {
            margin-left: 0.5rem;
            height: 1.5rem;
          }
        }
        >p {
          margin-bottom: 1.1875rem;
          padding: 0 0 .3125rem;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #eee;
          font-size: .8125rem;
          color: #333333;
          font-weight: bold;
          span:nth-child(1) {
            margin-left: .3125rem;
          }
          span:nth-child(2) {
            display: flex;
            align-items: center;
            u {
              margin-left: .125rem;
              display: flex;
              align-items: center;
              flex-direction: column;
              text-decoration:none;
              i {
                cursor: pointer;
                font-size: .6875rem;
                font-weight: bold;
              }
              i:hover {
                color: #5093F2;
              }
            }
          }
        }
        ul {
          height: calc(100vh - 10rem);
          overflow: auto;
          li {
            padding: 0 .75rem;
            display: flex;
            align-items: center;
            height: 2.2rem;
            width: 100%;
            box-sizing: border-box;
            border-radius: .25rem;
            cursor: pointer;
            text-align: left;
            font-size: .8125rem;
            font-weight: bold;
            img {
              margin-right: .3rem;
              width: .75rem;
              height: .75rem;
            }
            span {
              height: 1rem;
              line-height: 1rem;
            }
          }
          li:hover {
            background-color: #EFF6FF;
            color: #5093F2;
          }
          .active {
            background-color: #EFF6FF;
            color: #5093F2;
          }
        }
      }
    }
    .homePC {
      display: none;
    }
  }
  @media screen and (min-width: 901px) {
    .homeMobile {
      display: none;
    }
    .homePC {
      display: block;
      padding: 20px 38.5px 32.5px;
      width: 100%;
      height: 100vh;
      background: url('https://img.spolicy.com/FtPX4f7y1ShOfSJMu8XLifprgUyB') no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      header {
        margin-bottom: 22px;
        display: flex;
        align-items: center;
        height: 46px;
        img {
          margin: 0 15px 0 27px;
          height: 46px;
        }
      }
      main {
        display: flex;
        justify-content: space-between;
        height: calc(100vh - 120px);
        background-color: #fff;
        border-radius: 40px;
        overflow: hidden;
        aside {
          padding: 22px 36px;
          width: 318px;
          background-color: #fff;
          box-sizing: border-box;
          >p {
            margin-bottom: 19px;
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            color: #333333;
            font-weight: bold;
            span:nth-child(1) {
              margin-left: 5px;
            }
            span:nth-child(2) {
              display: flex;
              align-items: center;
              u {
                margin-left: 2px;
                display: flex;
                align-items: center;
                flex-direction: column;
                text-decoration:none;
                i {
                  cursor: pointer;
                  font-size: 10px;
                  font-weight: bold;
                }
                i:hover {
                  color: #5093F2;
                }
              }
            }
          }
          ul {
            height: calc(100vh - 260px);
            width: 246px;
            overflow: auto;
            li {
              padding: 10px 25px;
              display: flex;
              align-items: center;
              height: 38px;
              box-sizing: border-box;
              border-radius: 4px;
              cursor: pointer;
              text-align: left;
              font-size: 14px;
              font-weight: bold;
              img {
                margin-right: 3px;
                width: 14px;
                height: 14px;
              }
              span {
                height: 15px;
                line-height: 14px;
              }
            }
            li:hover {
              background-color: #EFF6FF;
              color: #5093F2;
            }
            .active {
              background-color: #EFF6FF;
              color: #5093F2;
            }
          }
          .setFooter {
            width: 100%;
            height: 22px;
            background-color: rgb(246, 246, 254);
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            line-height: 22px;
            font-weight: bold;
            color: #333;
          }
          .setFooter:hover {
            color: #007bff;
            background-color: #EFF6FF;
          }
        }
        article {
          flex: 1;
          display: flex;
          flex-direction: column;
          height: 100%;
          background: linear-gradient( 146deg, #F2F6FE 0%, #FAF7FF 100%);
          .artHeader {
            flex: 1;
            background: linear-gradient( 146deg, #F2F6FE 0%, #FAF7FF 100%);
            .tip  {
              margin: 20px 30px 0 7px;
              display: flex;
              justify-content: right;
              align-items: center;
              height: 32px;
              border-bottom: 1px dotted #CBD5E6;
              text-align: right;
              line-height: 62px;
              font-size: 13px;
              font-weight: bold;
              color: #555555;
              p {
                display: flex;
                align-items: center;
                img {
                  margin-right: 5px;
                  width: 21px;
                  height: 21px;
                  cursor: pointer;
                }
                span {
                  margin-top: 2px;
                  cursor: pointer;
                }
              }
            }
            .tip:hover {
              color: #5093F2;
            }
            .artBox {
              padding: 30px;
              height: calc(100vh - 333px);
              overflow: auto;
              .questionBox {
                margin-bottom: 24px;
                .contentBox {
                  width: 100%;
                  span {
                    display: block;
                    font-size: 14px;
                    font-weight: bold;
                    color: #ccc;
                  }
                  >div {
                    margin-left: 30%;
                    display: flex;
                    justify-content: right;
                    align-items: center;
                    width: 70%;
                    .messageP {
                      padding: 10px 15px;
                      background: #4887F9;
                      border-radius: 12px 12px 0px 12px;
                      border: .0625rem solid rgb(228, 231, 237);
                      box-shadow: rgba(31, 35, 41, 0.12) 0 .085rem .25rem;
                      line-height: 25px;
                      font-size: 15px;
                      font-weight: bold;
                      color: #fff;
                      text-align: left;
                    }
                    img {
                      margin-left: 10px;
                      width: 43px;
                      height: 43px
                    }
                  }
                }
              }
              .answerBox {
                margin-bottom: 24px;
                .contentBox {
                  width: 100%;
                  span {
                    display: block;
                    font-size: 14px;
                    font-weight: bold;
                    color: #ccc;
                  }
                  >div {
                    display: flex;
                    justify-content: left;
                    align-items: top;
                    width: 70%;
                    .messageP {
                      padding: 10px 15px;
                      background: #fff;
                      border-radius: 12px 12px 12px 0px;
                      border: .0625rem solid rgb(228, 231, 237);
                      box-shadow: rgba(31, 35, 41, 0.12) 0 .085rem .25rem;
                      line-height: 25px;
                      font-size: 15px;
                      font-weight: bold;
                      color: #333;
                      text-align: left;
                      li {
                        margin-bottom: 16px;
                      }
                      p {
                        span {
                          display: flex;
                          align-items: center;
                          cursor: pointer;
                          color: #333;
                          font-size: 14px;
                          font-weight: bold;
                          u {
                            margin-right: 6px;
                            display: inline-block;
                            width: 6px;
                            height: 6px;
                            border-radius: 50%;
                            background-color: #333;
                          } 
                        }
                        span:hover {
                          color: #4887F9;
                          u {
                            background-color: #4887F9;
                          }
                        }
                      }
                      .guessBox {
                        display: flex;
                        flex-wrap: wrap;
                        i {
                          margin: 4px 12px 4px 0;
                          padding: 6px 15px;
                          box-sizing: border-box;
                          border-radius: 30px;
                          border: 1px solid rgb(225, 226, 229);
                          cursor: pointer;
                          font-size: 12px;
                          line-height: 12px;
                          color: rgba(51, 51, 51);
                        }
                        i:hover {
                          border-color: rgb(76, 136, 246);
                          color: rgb(76, 136, 246);
                        }
                      }
                      >span {
                        display: inline-block;
                      }
                      .botCopy {
                        margin-top: 6px;
                        display: block;
                        width: 60px;
                        cursor: pointer;
                        color: #333;
                        i {
                          margin-right: 2px;
                          display: inline-block;
                        }
                      }
                      .botCopy:hover {
                        color: #007bff;
                      }
                    }
                    img {
                      margin-right: 10px;
                      width: 43px;
                      height: 43px
                    }
                  }
                }
              }
              .loadingDots, .loadingDots2, .loadingDots3 {
                margin-right: 6px;
                width: 6px;
                height: 6px;
                background-color: #000;
                border-radius: 50%;
                animation: loading 0.8s infinite ease-in-out;
              }
              .loadingDots2 {
                animation: loading2 0.8s infinite ease-in-out;
              }
              .loadingDots3 {
                animation: loading3 0.8s infinite ease-in-out;
              }
              @keyframes loading {
                0% { transform: scale(1.5); }
                50% { transform: scale(1); }
                100% { transform: scale(1); }
              }
              @keyframes loading2 {
                0% { transform: scale(1); }
                50% { transform: scale(1.5); }
                100% { transform: scale(1); }
              }
              @keyframes loading3 {
                0% { transform: scale(1); }
                50% { transform: scale(1); }
                100% { transform: scale(1.5); }
              }
            }
          }
          .artFooter {
            margin-left: 1px;
            padding: 20px 20px;
            display: flex;
            align-items: center;
            min-height: 86px;
            box-sizing: border-box;
            background-color: #fff;
            box-shadow: rgba(31, 35, 41, 0.12) 0 .085rem .25rem;
            /deep/ .el-textarea__inner {
              max-height: 47px;
              max-height: 123px;
              border: 0;
              resize: none;
              overflow-y: auto;
              font-size: 16px;
            }
            .lightBtn {
              width: 113px;
              height: 47px;
              background: linear-gradient( 180deg, rgb(100, 184, 255) 0%, rgb(72, 119, 249) 100%);
              border-radius: 24px 24px 24px 24px;
              font-size: 21px;
              font-weight: 500;
              // font-family: "SourceHanSancCN", "PingFang SC", "Microsoft YaHei", tahoma, system-ui, arial;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #fff;
            }
            .lightBtn:hover {
              background: linear-gradient( 180deg, rgba(100, 184, 255, .8) 0%, rgb(72, 119, 249, .1) 100%);
            }
            .stopBtn {
              width: 113px;
              height: 47px;
              background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(220, 220, 220, 0.1) 100%);
              border-radius: 24px 24px 24px 24px;
              font-size: 21px;
              font-weight: 500;
              // font-family: "SourceHanSancCN", "PingFang SC", "Microsoft YaHei", tahoma, system-ui, arial;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #333; /* 按钮文字颜色设置为黑色 */
            }

            .stopBtn:hover {
              background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(220, 220, 220, 0.3) 100%);
            }
          }
        }
      }
      /deep/ .configDialog {
        .el-dialog {
          width: 700px;
          border-radius: 8px;
          .el-dialog__header {
            padding: 12px 16px 12px;
            vertical-align: top;
            border-radius: 10px;
            background-color: rgb(251, 251, 252);
            font-weight: bold;
            text-align: left;
            .el-dialog__headerbtn {
              top: 16px;
            }
            .el-dialog__title {
              font-size: 16px;
              font-weight: bold;
            }
          }
          .el-dialog__body {
            padding: 16px 28px;
            width: 100%;
            box-sizing: border-box;
            ul {
              display: flex;
              justify-content: space-between;
              li {
                position: relative;
                width: 207px;
                height: 118px;
                cursor: pointer;
                border-radius: 8px;
                background-color: #eee;
                border: 1px solid #eee;
                background-image: url('@/assets/img/1.png');
                background-size: cover;
                background-position: center;
              }
              li:nth-child(2) {
                background-image: url('@/assets/img/2.png');
              }
              li:nth-child(3) {
                background-image: url('@/assets/img/3.png');
              }
              li:hover {
                border: 1px solid #007bff;
              }
              .activeLi {
                border: 1px solid #007bff;
                background-color: rgba(0, 0, 0, 0.8)
              }
              li.listItem {
                position: relative; /* 确保遮罩可以正确覆盖在列表项上 */
                overflow: hidden; /* 隐藏超出部分 */
              }
              .zoomMask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5); /* 遮罩背景颜色 */
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 0; /* 默认情况下不显示遮罩 */
                transition: opacity 0.3s ease; /* 添加过渡效果 */
                >i {
                  color: white;
                  font-size: 24px; /* 图标大小 */
                }
              }
              
              li.listItem:hover .zoomMask {
                opacity: 1; /* 当鼠标悬停时显示遮罩 */
              }
            }
            .configContent{
              margin-top: 32px;
              width: 100%;
              overflow: hidden;
              >p {
                padding: 0 12px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 45px;
                box-sizing: border-box;
                background-color: rgb(246, 248, 249);
                border: 1px solid rgb(223, 226, 234);
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
                line-height: 45px;
                text-align: left;
                color: rgb(72, 82, 100);
                font-weight: bold;
                font-size: 14px;
                i {
                  font-size: 14px;
                  font-weight: bold;
                  cursor: pointer;
                }
                i:hover {
                  color: #007bff;
                }
              }
              .configMain {
                padding: 12px;
                box-sizing: border-box;
                background-color: rgb(244, 244, 247);
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
                >p {
                  font-size: 14x;
                  font-weight: 500;
                  text-align: left;
                  overflow-y: hidden;
                  code {
                    // font-family: "SourceHanSancCN", "PingFang SC", "Microsoft YaHei", tahoma, system-ui, arial, "Hiragino Sans GB", sans-serif;
                    font-family: PingFangSC-Regular, PingFang SC;
                  }
                }
              }
            }
          }
        }
      }
      .fullscreenOverlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 99999;
        display: none; /* 初始隐藏 */
        >div {
          margin-top: 200px;
          margin-left: 50%;
          transform: translate(-50%);
          width: 50%;
          height: 50%;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
        >i {
          position: absolute;
          top: 10px;
          right: 10px;
          font-size: 24px;
          color: #fff;
        }
      }
      .fullscreenOverlay.active {
        display: block; /* 显示时显示 */
        background-color: rgba(0, 0, 0, 0.8); /* 可选：添加背景遮罩 */
        cursor: pointer;
      }
    }
  }
}
</style>
